<form class="container-sm padding-1 margin-top-1" [formGroup]="myFormGroup" fxLayout="column" *ngIf="myFormGroup">

    <div class="margin-top-1 padding-3 " fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="start stretch"
         [class.shadow-small]="myFormGroup.get('enabled').value"
         [class.color-grey-secondary-important]="!myFormGroup.get('enabled').value"
    >


        <div fxFlex>

            <div class="margin-top-2" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="start center" >
                <mat-slide-toggle formControlName="enabled" fxFlex="10" (change)="onSlideChanged($event)">
                    <span class="size-4"></span>

                </mat-slide-toggle>
                <mat-icon class="size-4" fxFlex="10">{{myFormGroup.controls.iconName.value}}</mat-icon>
                <span class="text-large" fxFlex="70"
                      [class.color-grey-secondary-important]="!myFormGroup.get('enabled').value">{{myFormGroup.controls.name.value}}</span>

<!--                <ng-container *ngIf="!myFormGroup.controls.price.enabled; else editablePriceInput">-->
<!--                    <span fxFlex="20">{{myFormGroup.controls.price.value.amountMicros / 1000000 | number:'1.0-0'}} {{myFormGroup.controls.price.value.currency}}</span>-->
<!--                </ng-container>-->
                <ng-container *ngIf="!myFormGroup.get('price').enabled; else editablePriceInput">
                    <span fxFlex="20">{{myFormGroup.get('price').value.amountMicros / 1000000 | number:'1.0-0'}} {{myFormGroup.get('price').value.currency}}</span>
                </ng-container>
                <ng-template #editablePriceInput>
                    <app-flok-form-field fxFlex="20" >
                        <app-flok-label>Price</app-flok-label>

                        <app-currency-amount-input formControlName="price"></app-currency-amount-input>
                    </app-flok-form-field>
                </ng-template>

            </div>

            <div class="margin-top-1" fxLayout="column" fxLayout.gt-xs="row">
                <div fxLayout="column" fxFlex>
                    <mat-form-field appearance="none" class="flok large" fxFlex>
                        <mat-label>Description</mat-label>

                        <input formControlName="description" matInput>
                    </mat-form-field>

                </div>
            </div>

        </div>
    </div>
</form>
